import ax from './axios';

export const checkWebinarsStatus = () => {
  return ax({
    url: `/rest/webinars/check-status/`,
    method: 'get',
  });
};
